/* eslint-disable */
/* @ts-ignore */
/**
 *
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 *
 * npm run graphql-codegen
 *
 * for this file to be re-created
 */
 
declare const module: {
  hot?: {
    accept: () => void;
    status: () => string;
  };
};

// @ts-ignore
const isHotReloadEnabled = typeof module !== 'undefined' && module.hot;

if (isHotReloadEnabled) {
  // @ts-ignore
  module.hot.accept();
}
import * as Types from '@/shared/types/types.generated';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { baseAuditApi } from '../../base-api';
export type AuditLogListItemFragment = { __typename: 'AuditLogResponseType', eventTimestamp: any, eventType: Types.AuditLogEventTypeSource, auditLogId: string, userMessage?: string, category?: Types.AuditLogCategory, creationUserId?: string };

export type AuditLogFragment = { __typename: 'AuditLogResponseType', eventTimestamp: any, eventType: Types.AuditLogEventTypeSource, auditLogId: string, userMessage?: string, category?: Types.AuditLogCategory, creationUserId?: string, data: any, changes?: Array<{ __typename: 'ChangeEntryType', field: string, type: Types.ChangeType, added?: any, removed?: any, identifier?: any, changes?: any, item?: any }> };

export type ExportAuditLogsCsvMutationVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.AuditLogFilterInput>;
  startDate?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  endDate?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
}>;


export type ExportAuditLogsCsvMutation = { __typename: 'Mutation', exportAuditLogsCsv: { __typename: 'AuditLogCsvExportTriggerResponseType', requestId: string, channel: string, message: string } };

export type ReadAllAuditLogsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.AuditLogFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadAllAuditLogsQuery = { __typename: 'Query', readAllAuditLogs: { __typename: 'PaginatedAuditLogResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'AuditLogResponseType', eventTimestamp: any, eventType: Types.AuditLogEventTypeSource, auditLogId: string, userMessage?: string, category?: Types.AuditLogCategory, creationUserId?: string }> } };

export type ReadAuditLogQueryVariables = Types.Exact<{
  auditLogId: Types.Scalars['String']['input'];
}>;


export type ReadAuditLogQuery = { __typename: 'Query', readAuditLog?: { __typename: 'AuditLogResponseType', eventTimestamp: any, eventType: Types.AuditLogEventTypeSource, auditLogId: string, userMessage?: string, category?: Types.AuditLogCategory, creationUserId?: string, data: any, changes?: Array<{ __typename: 'ChangeEntryType', field: string, type: Types.ChangeType, added?: any, removed?: any, identifier?: any, changes?: any, item?: any }> } };

export type ReadAuditLogsCountQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadAuditLogsCountQuery = { __typename: 'Query', readAllAuditLogs: { __typename: 'PaginatedAuditLogResponseType', itemCount: number } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const AuditLogListItemFragmentDoc = new TypedDocumentString(`
    fragment AuditLogListItem on AuditLogResponseType {
  __typename
  eventTimestamp
  eventType
  auditLogId
  userMessage
  category
  creationUserId
}
    `, {"fragmentName":"AuditLogListItem"});
export const AuditLogFragmentDoc = new TypedDocumentString(`
    fragment AuditLog on AuditLogResponseType {
  __typename
  eventTimestamp
  eventType
  auditLogId
  userMessage
  category
  creationUserId
  data
  changes {
    __typename
    field
    type
    added
    removed
    identifier
    changes
    item
  }
}
    `, {"fragmentName":"AuditLog"});
export const ExportAuditLogsCsvDocument = new TypedDocumentString(`
    mutation ExportAuditLogsCsv($filter: AuditLogFilterInput, $startDate: DateTime, $endDate: DateTime) {
  __typename
  exportAuditLogsCsv(filter: $filter, startDate: $startDate, endDate: $endDate) {
    __typename
    requestId
    channel
    message
  }
}
    `);
export const ReadAllAuditLogsDocument = new TypedDocumentString(`
    query ReadAllAuditLogs($filter: AuditLogFilterInput, $pagination: PaginationInput) {
  __typename
  readAllAuditLogs(filter: $filter, pagination: $pagination) {
    __typename
    items {
      __typename
      ...AuditLogListItem
    }
    itemCount
    pages
  }
}
    fragment AuditLogListItem on AuditLogResponseType {
  __typename
  eventTimestamp
  eventType
  auditLogId
  userMessage
  category
  creationUserId
}`);
export const ReadAuditLogDocument = new TypedDocumentString(`
    query ReadAuditLog($auditLogId: String!) {
  __typename
  readAuditLog(auditLogId: $auditLogId) {
    __typename
    ...AuditLog
  }
}
    fragment AuditLog on AuditLogResponseType {
  __typename
  eventTimestamp
  eventType
  auditLogId
  userMessage
  category
  creationUserId
  data
  changes {
    __typename
    field
    type
    added
    removed
    identifier
    changes
    item
  }
}`);
export const ReadAuditLogsCountDocument = new TypedDocumentString(`
    query ReadAuditLogsCount {
  __typename
  readAllAuditLogs {
    __typename
    itemCount
  }
}
    `);

const injectedRtkApi = baseAuditApi.injectEndpoints({
  overrideExisting: isHotReloadEnabled && module.hot?.status() === "apply",
  endpoints: (build) => ({
    ExportAuditLogsCsv: build.mutation<Types.ExportAuditLogsCsvMutation, Types.ExportAuditLogsCsvMutationVariables | void>({
      query: (variables) => ({ document: ExportAuditLogsCsvDocument as unknown as string, variables })
    }),
    ReadAllAuditLogs: build.query<Types.ReadAllAuditLogsQuery, Types.ReadAllAuditLogsQueryVariables | void>({
      query: (variables) => ({ document: ReadAllAuditLogsDocument as unknown as string, variables })
    }),
    ReadAuditLog: build.query<Types.ReadAuditLogQuery, Types.ReadAuditLogQueryVariables>({
      query: (variables) => ({ document: ReadAuditLogDocument as unknown as string, variables })
    }),
    ReadAuditLogsCount: build.query<Types.ReadAuditLogsCountQuery, Types.ReadAuditLogsCountQueryVariables | void>({
      query: (variables) => ({ document: ReadAuditLogsCountDocument as unknown as string, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useExportAuditLogsCsvMutation, useReadAllAuditLogsQuery, useLazyReadAllAuditLogsQuery, useReadAuditLogQuery, useLazyReadAuditLogQuery, useReadAuditLogsCountQuery, useLazyReadAuditLogsCountQuery } = injectedRtkApi;

